import { render, staticRenderFns } from "./ModalHandleLoading.vue?vue&type=template&id=345d958a&scoped=true"
import script from "./ModalHandleLoading.vue?vue&type=script&lang=js"
export * from "./ModalHandleLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345d958a",
  null
  
)

export default component.exports